import React, { useContext, Fragment } from 'react';

import { AppContext } from './context';
import Loading from './Loading';
import Header from './Header';
import Footer from './Footer';

const Layout = (props) => {
  const { isLoaded } = useContext(AppContext);
 
  if (isLoaded && props.isLoaded) {
    return (
      <Fragment>
        <Header />
        <main className="Main">
          {props.children}
        </main>
        <Footer />
      </Fragment>
    );
  }

  return <Loading />;
}

export default Layout;